export const getMoonpigApiCursorSecretHeader = (): Record<string, string> => {
  const secret = process.env.MNPG_TUNNEL_SECRET_CURSOR
  const API_TUNNEL_SECRET_HEADER = 'x-mnpg-cursor-tunnel-secret'

  return secret ? { [API_TUNNEL_SECRET_HEADER]: secret } : {}
}

export const getAuthCursorSecretHeader = (): Record<string, string> => {
  const secret = process.env.MNPG_TUNNEL_SECRET_CURSOR
  const AUTH_CURSOR_SECRET_HEADER = 'x-mnpg-auth-cursor-key'

  return secret ? { [AUTH_CURSOR_SECRET_HEADER]: secret } : {}
}

export const getCloudflareBypassHeader = (): Record<string, string> => {
  return {
    'mnpg-edge-api-waf-bypass':
      process.env.MNPG_EDGE_API_WAF_BYPASS || /* istanbul ignore next */ '',
  }
}
